import moment from 'moment';

export const formatYearMonth = (yearMonth: string): string => {
  const formatted = moment(yearMonth, 'YYYY-MM').utc().format('MMMM YYYY');
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};
